<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('shopProductType.queryCondition') }}</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="housekeepingTypeInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="housekeepingTypeInfo.conditions.hktName"
              :placeholder="$t('shopProductType.inputMenuName')" clearable />
          </el-form-item>
          <el-form-item>
            <el-select v-model="housekeepingTypeInfo.conditions.isShow"
              :placeholder="$t('shopProductType.selectShowStatus')" style="width:100%">
              <el-option :label="$t('shopProductType.all')" value="" />
              <el-option :label="$t('shopProductType.yes')" value="Y" />
              <el-option :label="$t('shopProductType.no')" value="N" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryHousekeepingTypeMethod">
              {{ $t('shopProductType.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('shopProductType.mallMenu') }}</span>
        <div style="float:right">
          <el-button type="primary" size="small" @click="_openAddAShopMenuModal">
            <i class="el-icon-plus" />{{ $t('shopProductType.shopMenu') }}
          </el-button>
          <el-button type="primary" size="small" @click="_openAddAGoodsMenuModal">
            <i class="el-icon-plus" />{{ $t('shopProductType.goodsMenu') }}
          </el-button>
          <el-button type="primary" size="small" @click="_openAddAServTypeMenuModal">
            <i class="el-icon-plus" />{{ $t('shopProductType.servTypeMenu') }}
          </el-button>
          <el-button type="primary" size="small" @click="_openAddAServMenuModal">
            <i class="el-icon-plus" />{{ $t('shopProductType.servMenu') }}
          </el-button>
          <el-button type="primary" size="small" @click="_openAddAMenuModal">
            <i class="el-icon-plus" />{{ $t('shopProductType.outsideMenu') }}
          </el-button>
          <el-button type="primary" size="small" @click="_openAddAPhoneMenuModal">
            <i class="el-icon-plus" />{{ $t('shopProductType.phoneMenu') }}
          </el-button>
        </div>
      </div>
      <el-table :data="housekeepingTypeInfo.housekeepingTypes" border style="width: 100%">
        <el-table-column prop="hktIcon" :label="$t('shopProductType.logo')" align="center" width="120">
          <template slot-scope="scope">
            <img :src="scope.row.hktIcon" style="width: 60px; height: 60px; border-radius: 5px;">
          </template>
        </el-table-column>
        <el-table-column prop="hktName" :label="$t('shopProductType.menuName')" align="center" />
        <el-table-column prop="hktDesc" :label="$t('shopProductType.menuDesc')" align="center" />
        <el-table-column prop="label" :label="$t('shopProductType.label')" align="center" />
        <el-table-column prop="seq" :label="$t('shopProductType.sort')" align="center" />
        <el-table-column prop="skipType" :label="$t('shopProductType.skipType')" align="center">
          <template slot-scope="scope">
            {{ getSkipTypeLabel(scope.row.skipType) }}
          </template>
        </el-table-column>
        <el-table-column prop="isShow" :label="$t('shopProductType.isShow')" align="center">
          <template slot-scope="scope">
            {{ scope.row.isShow === 'Y' ? $t('shopProductType.yes') : $t('shopProductType.no') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('shopProductType.operation')" align="center" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openEditHousekeepingTypeModel(scope.row)">
              {{ $t('shopProductType.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="_openDeleteHousekeepingTypeModel(scope.row)">
              {{ $t('shopProductType.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="housekeepingTypeInfo.conditions.page" :page-sizes="[10, 20, 30, 50]"
        :page-size="housekeepingTypeInfo.conditions.row" layout="total, sizes, prev, pager, next, jumper"
        :total="housekeepingTypeInfo.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </el-card>

    <add-a-menu ref="addAMenu" @success="_listHousekeepingTypes" />
    <delete-mall-menu ref="deleteMallMenu" @success="_listHousekeepingTypes" />
    <add-a-shop-menu ref="addAShopMenu" @success="_listHousekeepingTypes" />
    <edit-mall-menu ref="editMallMenu" @success="_listHousekeepingTypes" />
    <add-a-goods-menu ref="addAGoodsMenu" @success="_listHousekeepingTypes" />
    <add-a-serv-type-menu ref="addAServTypeMenu" @success="_listHousekeepingTypes" />
    <add-a-serv-menu ref="addAServMenu" @success="_listHousekeepingTypes" />
    <add-a-phone-menu ref="addAPhoneMenu" @success="_listHousekeepingTypes" />
  </div>
</template>

<script>
import { getHousekeepingTypeList } from '@/api/admin/shopProductType/shopProductTypeApi'
import AddAMenu from '@/components/phone/addAMenu/addAMenu'
import AddAPhoneMenu from '@/components/phone/addAPhoneMenu/addAPhoneMenu'
import DeleteMallMenu from '@/components/phone/deleteMallMenu'
import AddAShopMenu from '@/components/phone/addAShopMenu/addAShopMenu'
import EditMallMenu from '@/components/phone/editMallMenu/editMallMenu'
import AddAGoodsMenu from '@/components/phone/addAGoodsMenu/addAGoodsMenu'
import AddAServTypeMenu from '@/components/phone/addAServTypeMenu/addAServTypeMenu'
import AddAServMenu from '@/components/phone/addAServMenu/addAServMenu'

export default {
  name: 'ShopProductType',
  components: {
    AddAMenu,
    DeleteMallMenu,
    AddAShopMenu,
    EditMallMenu,
    AddAGoodsMenu,
    AddAServTypeMenu,
    AddAServMenu,
    AddAPhoneMenu
  },
  data() {
    return {
      housekeepingTypeInfo: {
        housekeepingTypes: [],
        total: 0,
        records: 1,
        moreCondition: false,
        hktId: '',
        conditions: {
          hktName: '',
          isShow: '',
          shopId: '9999',
          typeCd: '2002',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listHousekeepingTypes()
  },
  methods: {
    getSkipTypeLabel(skipType) {
      if (skipType === '1') {
        return '站内'
      } else if (skipType === '2') {
        return '站外'
      } else if (skipType === '3') {
        return '手机菜单'
      }  
      return '未知'
    },
    handleSizeChange(val) {
      this.housekeepingTypeInfo.conditions.row = val
      this._listHousekeepingTypes()
    },
    handleCurrentChange(val) {
      this.housekeepingTypeInfo.conditions.page = val
      this._listHousekeepingTypes()
    },
    async _listHousekeepingTypes() {
      try {
        const res = await getHousekeepingTypeList(this.housekeepingTypeInfo.conditions)
        this.housekeepingTypeInfo.housekeepingTypes = res.data
        this.housekeepingTypeInfo.total = res.total
        this.housekeepingTypeInfo.records = res.records
      } catch (error) {
        console.error(error)
      }
    },
    _openAddAMenuModal() {
      this.$refs.addAMenu.open()
    },
    _openAddAShopMenuModal() {
      this.$refs.addAShopMenu.open()
    },
    _openAddAGoodsMenuModal() {
      this.$refs.addAGoodsMenu.open()
    },
    _openAddAServTypeMenuModal() {
      this.$refs.addAServTypeMenu.open()
    },
    _openAddAServMenuModal() {
      this.$refs.addAServMenu.open()
    },
    _openAddAPhoneMenuModal() {
      this.$refs.addAPhoneMenu.open()
    },
    _openEditHousekeepingTypeModel(row) {
      this.$refs.editMallMenu.open(row)
    },
    _openDeleteHousekeepingTypeModel(row) {
      this.$refs.deleteMallMenu.open(row)
    },
    _queryHousekeepingTypeMethod() {
      this.housekeepingTypeInfo.conditions.page = 1
      this._listHousekeepingTypes()
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}
</style>